export type VariablesGlobalState = {
  lastPatientDuplicateDate: number | null;
};

export const defaultVariablesGlobalState: VariablesGlobalState = {
  lastPatientDuplicateDate: null,
};
